/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Widgets.
 * @export
 */
export const ICON_WIDGETS = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <g id="widgets_24px">
      <path
        clipRule="evenodd"
        d="M11.2488 7.08626L15.4988 2.84626C15.8888 2.45626 16.5288 2.45626 16.9188 2.84626L21.1588 7.08626C21.5488 7.47626 21.5488 8.10626 21.1588 8.49626L16.9088 12.7463C16.5188 13.1363 15.8888 13.1363 15.4988 12.7463L11.2488 8.49626C10.8588 8.10626 10.8588 7.47626 11.2488 7.08626ZM2.54875 4.44626V10.4463C2.54875 10.9963 2.99875 11.4463 3.54875 11.4463H9.54875C10.0988 11.4463 10.5488 10.9963 10.5488 10.4463V4.44626C10.5488 3.89626 10.0988 3.44626 9.54875 3.44626H3.54875C2.99875 3.44626 2.54875 3.89626 2.54875 4.44626ZM9.54875 21.4463H3.54875C2.99875 21.4463 2.54875 20.9963 2.54875 20.4463V14.4463C2.54875 13.8963 2.99875 13.4463 3.54875 13.4463H9.54875C10.0988 13.4463 10.5488 13.8963 10.5488 14.4463V20.4463C10.5488 20.9963 10.0988 21.4463 9.54875 21.4463ZM12.5488 20.4463V14.4463C12.5488 13.8963 12.9988 13.4463 13.5488 13.4463H19.5488C20.0988 13.4463 20.5488 13.8963 20.5488 14.4463V20.4463C20.5488 20.9963 20.0988 21.4463 19.5488 21.4463H13.5488C12.9988 21.4463 12.5488 20.9963 12.5488 20.4463Z"
        fillRule="evenodd"
        id="icon/device/widgets_24px"
      />
    </g>
  </svg>
);
